var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "goldCircle",
    cx: "38%",
    cy: "32%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5DC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#E4CE4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "darkText",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0e00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "textShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0.3,
    stdDeviation: 0.3,
    floodColor: "#000",
    floodOpacity: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#goldCircle)",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.603 6.912c1.738 1.227 3.548 1.364 5.863 1.79 2.106.391 2.553 2.542 1.591 5.28a9.384 9.384 0 00-.18-.292l.18.292-.017.045.017-.045c1.467 2.492 1.456 5.191-1.719 6.572-5.653 2.46-5.99 7.305-11.333 4.697A6.71 6.71 0 0111 23.74l-.208-.237-.193-.033c-3.586-.635-5.94-2.579-3.762-7.539 1.927-4.383.206-8.696 6.116-8.504h.002c1.628-1.527 3.505-2.024 5.647-.515z",
    fill: "#FFF",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13.2,
    stroke: "#FFF",
    strokeWidth: 0.3,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 20.5,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 13,
    fontWeight: "bold",
    fontStyle: "italic",
    fill: "url(#darkText)",
    filter: "url(#textShadow)",
    letterSpacing: 0.5
  }, "MG"), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 22,
    x2: 21.5,
    y2: 22,
    stroke: "#1a0e00",
    strokeWidth: 0.5,
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMg);
export default __webpack_public_path__ + "static/media/mg.985c48d3417096dd23cd78792b2ed469.svg";
export { ForwardRef as ReactComponent };